import React, {Component} from 'react'
import {
    getUserRightDataList,
    deleteUserRightData, getUserRightOptionsList,
    getRightUserList, saveUserRightData, delDataRightItem
} from '../../request'
import {Button, Modal, Popconfirm, Table, Drawer, message} from "antd";
import UserDataRightDetail from "./UserDataRightDetail";
let columnsKey = {
    index: '序号',
    userName: '用户名',
    bussName: "业务模块",
    dataFields: "数据权限",
    hiddenFields: "隐藏字段",
    editFields: "编辑字段",
    operation: "操作",
}
class UserDataRight extends Component {
    userDataRightDrawer = React.createRef()
    state = {
        dataRightList: [],
        columns:[],
        loading:false,
        dataRightVisible:false,
        resourceId:null
    }
    createColumns = (createKeys)=>{
        let columns = Object.keys(createKeys).map(item=>{
            let initObj = {
                title:createKeys[item],
                dataIndex:item,
                key:item,
                align:'center'
            }
            if(item=='index'){
                return {
                    ...initObj,
                    width:40,
                    fixed: 'left',
                    render:(text,record,index)=>{
                        return index+1
                    }
                }
            }else if(item=='dataFields'){
                return {
                    ...initObj,
                    align: 'left',
                    render:(text,record,index)=>{
                        return (
                            <>
                                {
                                    text?
                                        text.map(field=>{
                                            return (
                                                <div>
                                                    {field.fieldName}:{field.selectValue}
                                                </div>
                                            )
                                        }):''
                                }
                            </>
                        )
                    }
                }
            }else if(item=='hiddenFields'||item=='editFields'){
                return {
                    ...initObj,
                    render:(text,record,index)=>{
                        return (
                            <>
                                {
                                    text?text.join(','):''
                                }
                            </>
                        )
                    }
                }
            }else if(item == 'operation'){
                return  {
                    ...initObj,
                    fixed: 'right',
                    width: 120,
                    render: (text, record, index) => {
                        return (
                            <>
                                <Button type="link" size="small" onClick={() => this.addUserRight(record)}>编辑</Button>
                                <Popconfirm
                                    title="确定要删除该条数据吗？"
                                    onConfirm={()=>this.deleteItem(record)}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Button type="link" size="small">删除</Button>
                                </Popconfirm>
                            </>
                        )
                    }
                }
            }else{
                return initObj
            }
        })
        this.setState({
            columns,
        })
    }

    getRightList = (resourceId)=> {
        getUserRightDataList({menuId:resourceId}).then(res=> {
            this.setState({
                dataRightList: res
            })
        })
    }
    addUserRight = (record)=>{
        this.userDataRightDrawer.current.openUserRightDetail(record)
    }
    deleteItem = (values)=>{
        deleteUserRightData({
            id:values.id
        }).
        then(res=>{
            message.success('删除成功')
            this.getRightList(this.state.resourceId)
        })
    }
    openUserRight = (resourceId)=>{
        this.getRightList(resourceId)
        this.setState({
            dataRightVisible:true,
            resourceId
        })
    }
    closeDrawer = () => {
        this.setState({
            dataRightVisible:false
        })
    }
    componentDidMount() {
        this.createColumns(columnsKey);

    }
    render() {
        console.log(this.props)
        let {columns,loading} = this.state
        return (
            <>
                <Drawer title="数据权限" width={'70%'} onClose={this.closeDrawer} open={this.state.dataRightVisible}>
                    <div>
                        <Button type="primary" onClick={()=>this.addUserRight({id:null})}>批量新增</Button>
                    </div>
                    <Table
                        bordered
                        size="small"
                        pagination={false}
                        dataSource={this.state.dataRightList}
                        rowKey="id"
                        columns={columns}
                        loading={loading}/>
                    <UserDataRightDetail ref={this.userDataRightDrawer} resourceId={this.state.resourceId} onRefreshList={()=>this.getRightList(this.state.resourceId)}/>
                </Drawer>
            </>
        )
    }
}
export default UserDataRight